import React from 'react';
import {Info} from 'lucide-react';
export default function WordMeaningButton({word,onClick,className=''}){
 return <button type="button" className={`word-meaning-button-r34 ${className}`} aria-label={`${word} kelimesinin anlamı`} title="Kelimenin anlamı" onClick={onClick}><Info size={18} aria-hidden="true"/></button>;
}
